import { createSlice } from '@reduxjs/toolkit'

export const DocumentationSlice = createSlice({
  name: 'documentationFlag',
  initialState: {
    value: {},
  },
  reducers: {
    setDocumentFlag: (state, action) => {
        if(action.payload.type){
            return { ...state,
                value:{
                  ...state.value,[action.payload.type]: action.payload.value
                }              
            }
        }
        else{
          state.value = action.payload
        }
    },
  },
})

export const { setDocumentFlag } = DocumentationSlice.actions

export default DocumentationSlice.reducer